import Orders from "@/views/Shop/Order/Orders.vue";
import OrderView from "@/views/Shop/Order/OrderView.vue";
import Options from "@/views/Shop/Options/Options.vue";
import OptionsCreate from "@/views/Shop/Options/OptionsCreate.vue";
import OptionsEdit from "@/views/Shop/Options/OptionsEdit.vue";
import OtherSettings from "@/views/Shop/OtherSettings/OtherSettings.vue";
import DiscountCodes from "@/views/Shop/DiscountCodes/DiscountCodes.vue";
import DiscountCodesCreate from "@/views/Shop/DiscountCodes/DiscountCodesCreate.vue";
import DiscountCodesEdit from "@/views/Shop/DiscountCodes/DiscountCodesEdit.vue";
import NexiChargeList from "@/views/Shop/NexiCharge/NexiChargeList.vue";
import NexiChargeNew from "@/views/Shop/NexiCharge/NexiChargeNew.vue";
const routes = [
    {
        path: "/shop/orders",
        name: "Orders",
        component: Orders,
    },
    {
        path: "/shop/orders/view/:order_uuid",
        name: "OrderView",
        component: OrderView,
    },
    {
        path: "/shop/options",
        name: "Options",
        component: Options,
    },
    {
        path: "/shop/discount-codes",
        name: "Discount Codes",
        component: DiscountCodes
    },
    {
        path: "/shop/discount-codes/create",
        name: "DiscountCodesCreate",
        component: DiscountCodesCreate
    },
    {
        path: "/shop/discount-codes/edit/:discount_code_uuid",
        name: "DiscountCodesEdit",
        component: DiscountCodesEdit
    },
    {
        path: "/shop/options/create",
        name: "OptionsCreate",
        component: OptionsCreate,
    },
    {
        path: "/shop/options/edit/:option_uuid",
        name: "OptionsEdit",
        component: OptionsEdit,
    },
    {
        path: "/shop/other-settings",
        name: "OtherSettings",
        component: OtherSettings,
    },
    {
        path: "/shop/nexi-addebiti",
        name: "NexiChargeList",
        component: NexiChargeList,
    },
    {
        path: "/shop/nexi-addebiti/new",
        name: "NexiChargeNew",
        component: NexiChargeNew,
    },
];
export default routes;
